import { EntityPresenterMode, isStaticMode } from './presenterEntityMode';

import type { Maybe } from '@nova/core';
import type { CarrierCompanyDetails, CarrierUserDetails } from './carrierPresenterShared';

export function nestedCompanyPresenterDataProps(
  mode: EntityPresenterMode,
  data: { carrier?: Maybe<CarrierUserDetails>; company?: Maybe<CarrierCompanyDetails> }
) {
  if (isStaticMode(mode)) {
    return {
      staticCarrierData: data.carrier ?? null,
      staticCompanyData: data.company ?? null
    };
  }

  return {
    placeholderCarrierData: data.carrier ?? null,
    placeholderCompanyData: data.company ?? null
  };
}
